import { render, staticRenderFns } from "./AlarmDetail.vue?vue&type=template&id=a6bd7f3e&scoped=true"
import script from "./AlarmDetail.vue?vue&type=script&lang=ts"
export * from "./AlarmDetail.vue?vue&type=script&lang=ts"
import style0 from "./AlarmDetail.vue?vue&type=style&index=0&id=a6bd7f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd7f3e",
  null
  
)

export default component.exports